<script>
import BoxedLoader from '@maison/components/common/BoxedLoader';
import storeResultsInModal from '@phoenix/mixins/components/store/storeResultsInModal';
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: { BoxedLoader, PhxIcon },

  mixins: [storeResultsInModal],

  props: {
    followBoutiqueAppointmentUrl: {
      type: Boolean,
      required: false,
    },
    productReference: {
      type: String,
      default: null,
    },
  },

  methods: {
    onClick(store) {
      if (this.followBoutiqueAppointmentUrl) {
        window.location.href = window.route('boutique_appointment_form', {
          page_id: store.id,
          product_reference: this.productReference,
        });
      }

      if (!this.followStoreLinkOnClick) {
        return this.storeClick(store);
      }
    },
  },
};
</script>

<template>
  <div v-if="isLoading">
    <boxed-loader />
  </div>

  <ul v-else-if="hasStore" class="list list--divided stores-list">
    <li v-for="store in stores" :key="store.id" data-cy="store-result-item" class="stores-list-item">
      <button class="stores-list-item__button" data-cy="stores-list-item-btn" @click="onClick(store)">
        <h2 class="stores-list-item__title h6">{{ store.name }}</h2>
        <div class="stores-list-item__address">{{ getFullAddress(store) }}</div>
        <div class="stores-list-item__icon-wrapper">
          <phx-icon icon="chevron-right" class="icon--2xs" bidirectional />
        </div>
      </button>
    </li>
  </ul>

  <div v-else-if="displayNoResult" class="my-xl">
    <div v-if="noResultTitle" class="headings headings--centered">
      <h2 class="h2">
        {{ noResultTitle }}
      </h2>
    </div>
    <p v-if="noResultText" class="text-center text-muted">
      {{ noResultText }}
    </p>
    <div v-if="noResultCTA" class="text-center mt-base">
      <c-t-a v-bind="noResultCTA" />
    </div>
  </div>
</template>

<style>
.modal__header.modal__header--no-body {
  padding-bottom: 0;
  border: 0;
}
</style>
